<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "App",
  created() {
    window.addEventListener("beforeunload", () => {
      Cookies.set("storeCache", JSON.stringify(this.$store.state));
    });
    // 获取localStorage中的store数据
    const storeCache = Cookies.get("storeCache");
    if (storeCache) {
      // 将localStorage中的store数据替换到store中
      const oldStore = JSON.parse(storeCache);
      if (oldStore.page) {
        delete oldStore.page;
      }
      const merge = Object.assign(this.$store.state, oldStore);
      this.$store.replaceState(merge);
      Cookies.remove("storeCache");
    }
  },
};
</script>
